import {AsyncValidatorFn, FormControl, ValidatorFn} from "@angular/forms";
import {Observable, ReplaySubject, Subject} from "rxjs";
import {FUIFormControlState} from "@fedeltapointofsale/ui";

export class EntityFormControl extends FormControl implements FUIFormControlState {
    path: string;
    private _restricted: boolean;
    private _$statusChange: Subject<void> = new ReplaySubject(1);
    public $statusChange: Observable<void> = this._$statusChange.asObservable();

    public overriddenRequired: boolean;

    private _required: boolean;

    required$: ReplaySubject<boolean>;
    validators$: ReplaySubject<boolean>;

    constructor(path: string, formState: any, validator: ValidatorFn | ValidatorFn[] | any, asyncValidator: AsyncValidatorFn | AsyncValidatorFn[] | any) {
        super(formState, validator, asyncValidator);
        this.path = path;

        this.required$ = new ReplaySubject(1);
        this.validators$ = new ReplaySubject(1);
    }

    public set restricted(restricted: boolean) {
        this._restricted = restricted;
        this._$statusChange.next();
    }

    public get restricted(): boolean {
        return this._restricted;
    }

    public set required(required: boolean) {
        if (!this.overriddenRequired) {
            this._required = required;
            this.required$.next(required);
        }
    }

    public get required(): boolean {
        return this._required;
    }

    public set overrideRequired(required: boolean) {
        this.overriddenRequired = false;
        this.required = required;
        this.overriddenRequired = true;
    }

    public set validators(required: boolean) {
        this.validators$.next(required);
    }
}
